import { render, staticRenderFns } from "./LandingPageEN.vue?vue&type=template&id=1c7ea244&scoped=true"
import script from "./LandingPageEN.vue?vue&type=script&lang=js"
export * from "./LandingPageEN.vue?vue&type=script&lang=js"
import style0 from "../../assets/landing/styles.css?vue&type=style&index=0&id=1c7ea244&prod&scoped=true&lang=css&external"
import style1 from "./LandingPageEN.vue?vue&type=style&index=1&id=1c7ea244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7ea244",
  null
  
)

export default component.exports